import React from "react";
import { isAuthorised } from "../../utils/common";
import CustomDropdown from "../Dropdown/Dropdown";


/**
 * ColumnCell
 * 
 * Renders an interactive control (e.g. dropdown) if the logged-in officer
 * has the required role + permission for this column, otherwise renders
 * plain read-only text.
 *
 * Props:
 *   officer        {Object}    - logged-in officer from sessionStorage / Redux
 *   columnKey      {string}    - key to look up in moduleConfig, e.g. "ro_name"
 *   moduleConfig   {Object}    - e.g. APPLICATION_COLUMN_RULES
 *   displayText    {string}    - fallback text shown when not authorised (or as placeholder)
 *   value          {any}       - current value for the dropdown
 *   options        {Array}     - dropdown options [{ key, value, label }]
 *   onChange       {Function}  - (newValue, newLabel) => void
 *   renderLabel    {Function}  - (value, option) => string
 *   headerLabel    {string}    - dropdown header label
 *   fallback       {ReactNode} - optional custom fallback if not authorised
 */
const ColumnCell = ({
    officer,
    columnKey,
    moduleConfig,
    displayText,
    value,
    options = [],
    onChange,
    renderLabel,
    headerLabel,
    fallback = null,
}) => {
    const canAccess = isAuthorised(officer, moduleConfig?.[columnKey]);

    if (!canAccess) {
        // Render fallback if provided, otherwise plain text
        return fallback ?? <span>{displayText}</span>;
    }

    return (
        <CustomDropdown
            value={value}
            placeholder={displayText}
            options={options}
            onChange={onChange}
            renderLabel={renderLabel}
            headerLabel={headerLabel}
        />
    );
};

export default ColumnCell;